import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import {
  DetailedReactions,
  ResourceType,
  ReactionType,
} from 'js/social/shared/types';

export async function getReactions(
  id: number | string,
  resourceType: ResourceType,
): Promise<DetailedReactions> {
  const route = {
    post: routes.api_v0_community_post_reactions_path,
    paper_update: routes.api_v0_community_paper_update_reactions_path,
    comment: routes.api_v0_community_comment_reactions_path,
    openalex_work: (_: any) => '',
    work: routes.api_v0_community_work_reactions_path,
    paper_set: routes.api_v0_community_paper_set_reactions_path,
  }[resourceType];

  const response = await fetchWithCsrf(
    route({ subdomain_param: 'api', [`${resourceType}_id`]: id }),
  );
  if (response.status !== 200) {
    throw new Error('Failed to get reactions');
  }

  return await response.json();
}

export async function createReaction(
  id: number | string,
  resourceType: ResourceType,
  reactionType: ReactionType,
) {
  const route = {
    post: routes.api_v0_community_post_reaction_path,
    paper_update: routes.api_v0_community_paper_update_reaction_path,
    comment: routes.api_v0_community_comment_reaction_path,
    openalex_work: routes.api_v0_community_openalex_work_reaction_path,
    work: routes.api_v0_community_work_reaction_path,
    paper_set: routes.api_v0_community_paper_set_reaction_path,
  }[resourceType];

  const body =
    resourceType === 'openalex_work'
      ? { reaction_type: reactionType, numeric_id: id }
      : { reaction_type: reactionType };

  const response = await fetchWithCsrf(
    route({ subdomain_param: 'api', [`${resourceType}_id`]: id }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
  if (response.status !== 201) {
    throw new Error('Failed to create reaction');
  }
}

export async function deleteReaction(
  id: number | string,
  resourceType: ResourceType,
  reactionType: ReactionType,
) {
  const route = {
    post: routes.api_v0_community_post_reaction_path,
    paper_update: routes.api_v0_community_paper_update_reaction_path,
    comment: routes.api_v0_community_comment_reaction_path,
    openalex_work: routes.api_v0_community_openalex_work_reaction_path,
    work: routes.api_v0_community_work_reaction_path,
    paper_set: routes.api_v0_community_paper_set_reaction_path,
  }[resourceType];

  const body =
    resourceType === 'openalex_work'
      ? { reaction_type: reactionType, numeric_id: id }
      : { reaction_type: reactionType };

  const response = await fetchWithCsrf(
    route({ subdomain_param: 'api', [`${resourceType}_id`]: id }),
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
  if (response.status !== 204) {
    throw new Error('Failed to delete reaction');
  }
}
